import React from 'react';

import { BlockInnerText, LogosGrid } from './';
import { LogosGridProps } from './LogosGrid';
import { getSettingsClass } from '~/utils/helpers';
import { graphql } from 'gatsby';

interface TextWithLogosGridProps {
  block: {
    settings: Settings;
    pre_title: string;
    title: string;
    title_size: TitleSize;
    text: string;
    logos_grid: LogosGridProps;
  };
}

export const TextWithLogosGrid: React.FC<TextWithLogosGridProps> = ({
  block,
}) => {
  const { settings, logos_grid } = block;
  const settingsClass = getSettingsClass(settings);

  return (
    <div className={`block block__text_with_logos_grid ${settingsClass}`}>
      <BlockInnerText
        pre_title={block.pre_title}
        title={block.title}
        title_size={block.title_size}
        text={block.text}
      />
      <LogosGrid {...logos_grid} />
    </div>
  );
};

export const textWithLogosGridFragment = graphql`
  fragment TextWithLogosGridFragment on Block {
    pre_title
    title
    title_size {
      mobile
      desktop
    }
    text
    logos_grid {
      column_count
      scale_on_hover
      background_color
      logos {
        alt
        title
        url
      }
    }
    settings {
      ...SettingsFragment
    }
  }
`;
